module.exports = __webpack_public_path__ + "img/pick_players.5c257494.png";